import { render, staticRenderFns } from "./DocSubtypeDetail.vue?vue&type=template&id=5ae12f40"
import script from "./DocSubtypeDetail.vue?vue&type=script&lang=js"
export * from "./DocSubtypeDetail.vue?vue&type=script&lang=js"
import style0 from "./DocSubtypeDetail.vue?vue&type=style&index=0&id=5ae12f40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports